/**
 * Single source of truth for the CARTO basemap tile layer.
 *
 * CARTO now requires an API key for their basemaps. Without one, tiles still
 * return HTTP 200 but CARTO stamps an "API key required" watermark onto the
 * image, so a missing key looks like a styling bug rather than a failed
 * request. Request a free key (no account needed) at:
 *   https://carto.com/basemaps/apikey/
 *
 * The key is appended only when VITE_CARTO_BASEMAP_KEY is set, so behavior is
 * unchanged in any environment where it is missing.
 *
 * CARTO/OpenStreetMap attribution must stay visible — that is a condition of
 * the free tier. Do not remove BASEMAP_ATTRIBUTION from the TileLayer.
 */

const BASEMAP_TILE_BASE_URL =
  'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';

const basemapKey = import.meta.env.VITE_CARTO_BASEMAP_KEY;

export const BASEMAP_TILE_URL = basemapKey
  ? `${BASEMAP_TILE_BASE_URL}?key=${encodeURIComponent(basemapKey)}`
  : BASEMAP_TILE_BASE_URL;

export const BASEMAP_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> | &copy; <a href="https://carto.com/attributions">CARTO</a>';

export const BASEMAP_MAX_ZOOM = 19;
